import { Checkbox, Drawer, Flex, Link, Text } from '@servicetitan/anvil2';
import { useEffect, useState } from 'react';
import { TurnsDisclosureText } from './TurnsDisclosureText';
import { DisclosureDataStore } from './DisclosureStore';
import {
    useProviderConfig,
    useSecondLookIntegration,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';

export const WellsFargoDisclosure = () => {
    const [showTerms, setShowTerms] = useState(false);
    const { setAgreedToDisclosures } = DisclosureDataStore.useStore();
    const { prequalAcknowledgementText, turnsCoapplicationDisclosureText } = useProviderConfig();
    const { secondLookProvider } = useSecondLookIntegration();
    const secondLookProviderName = useSecondLookProviderName();
    const isTurnsSecondLook = secondLookProvider?.toLowerCase() === 'turns';

    // The checkbox is uncontrolled and starts unchecked on every mount.
    // Sync the store to match, so stale `true` from a previous submission
    // doesn't leave the submit button enabled while the checkbox is unchecked.
    useEffect(() => {
        setAgreedToDisclosures(false);
    }, [setAgreedToDisclosures]);

    return (
        <Flex direction="column" gap="4">
            <Flex direction="row" gap="2">
                <Checkbox
                    aria-label="I agree to Wells Fargo prequalification and Turns financing terms"
                    onChange={(e, state) => setAgreedToDisclosures(state?.checked ?? false)}
                />
                <Flex direction="column" gap="2">
                    <Text>{prequalAcknowledgementText}</Text>
                    <Text>
                        {turnsCoapplicationDisclosureText}{' '}
                        <Link onClick={() => setShowTerms(true)}>View terms</Link>
                    </Text>
                </Flex>
            </Flex>
            {showTerms && (
                <Drawer open onClose={() => setShowTerms(false)}>
                    <Drawer.Header>{secondLookProviderName} Financing Terms</Drawer.Header>
                    <Drawer.Content>{isTurnsSecondLook && <TurnsDisclosureText />}</Drawer.Content>
                </Drawer>
            )}
        </Flex>
    );
};
